// extracted by mini-css-extract-plugin
module.exports = {"table-source-description-wrapper":"TableSourceDescription_table-source-description-wrapper__1up7v"};